






import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const setting = namespace("setting");

@Component({})
export default class ShowSettlement extends Vue {
  @setting.State serviceMode;
  @Prop({ default: () => ({}) })
  orderData: any;
  get $show() {
    if (this.orderData.orderSource === "2") {
      // 天猫订单没有收款
      return false;
    }
    if (this.orderData.orderType !== "1" && this.orderData.settlementStatus === "0" && this.orderData.arrivalShop) {
      return true;
    }
    if (this.serviceMode === "1") {
      if (this.orderData.orderStatus === "4" && this.orderData.settlementStatus === "0" && this.orderData.arrivalShop) {
        return true;
      }
    } else if (this.serviceMode === "2") {
      if (
        (this.orderData.orderStatus === "2" || this.orderData.orderStatus === "4") &&
        this.orderData.settlementStatus === "0" &&
        this.orderData.arrivalShop
      ) {
        return true;
      }
    } else {
      if (this.orderData.orderStatus === "4" && this.orderData.settlementStatus === "0" && this.orderData.arrivalShop) {
        return true;
      }
    }
    return false;
  }
}
